import { render, staticRenderFns } from "./ArchiveAssessments.vue?vue&type=template&id=de285ad0"
import script from "./ArchiveAssessments.vue?vue&type=script&lang=js"
export * from "./ArchiveAssessments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports